export const toNaturalName = (str) => str !== null && str !== undefined && str.replace(/[\W_]+/g, ' ');
